import { map, scan } from "@pdfking/rfunc"
import { IsString } from "@pdfking/tfunc"

import selector from "./selector"

export default (elements: Element | Element[] | string, content: any): any => {
  return map(el => {
    scan(c => {
      if (IsString(c)) {
        el.innerHTML += c
      } else {
        el.appendChild(c)
      }
    }, content)
    return content
  }, selector(elements))
}
